/* Zentrale Auto-Versand-Helfer für Gäste-Nachrichten.
   Priorität:
     - Handy vorhanden -> WhatsApp öffnen
     - Nur E-Mail      -> Mail-Client öffnen
     - Beides          -> beides gleichzeitig
*/
import { toast } from "sonner";

export const OWNER_WHATSAPP = "017625799945"; // MainSpessartBlick WhatsApp-Business

function cleanPhone(p) {
  // wa.me will only digits, and 0-prefix must be replaced with country code 49 for DE mobile
  let n = String(p || "").replace(/[^0-9]/g, "");
  if (n.startsWith("00")) n = n.slice(2);
  else if (n.startsWith("0")) n = "49" + n.slice(1);
  return n;
}

function waUrl(phone, text) {
  const num = cleanPhone(phone);
  const enc = encodeURIComponent(text);
  return num ? `https://wa.me/${num}?text=${enc}` : `https://wa.me/?text=${enc}`;
}
function mailUrl(email, subject, body) {
  return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function buildWelcomeMessage(row) {
  const first = row.first_name || row.guest_name?.split(" ")[0] || row.name?.split(" ")[0] || "";
  const room  = row.room_name || "";
  const nights = row.nights || 0;
  return (
    `Hallo ${first},\n\n` +
    `herzlich willkommen im MainSpessartBlick! ` +
    `Ihr Zimmer (${room}) ist bereit für Sie und Ihren Aufenthalt von ${nights} ` +
    `${nights === 1 ? "Nacht" : "Nächten"}.\n\n` +
    `Wir wünschen Ihnen einen wundervollen Aufenthalt!\n\n` +
    `Familie Giombini · MainSpessartBlick\n` +
    `WhatsApp: ${OWNER_WHATSAPP}`
  );
}
export function buildThankYouMessage(row) {
  const first = row.first_name || row.guest_name?.split(" ")[0] || row.name?.split(" ")[0] || "";
  return (
    `Hallo ${first},\n\n` +
    `vielen Dank für Ihren Aufenthalt im MainSpessartBlick! ` +
    `Wir hoffen, es hat Ihnen bei uns gefallen und würden uns freuen, Sie bald wieder begrüßen zu dürfen.\n\n` +
    `Herzliche Grüße\n` +
    `Familie Giombini · MainSpessartBlick\n` +
    `WhatsApp: ${OWNER_WHATSAPP}`
  );
}

/**
 * autoSend – öffnet WhatsApp und/oder E-Mail-Client je nach vorhandenen Kontaktdaten.
 * @param {Object} row  { guest_phone, guest_email, first_name/last_name/name, room_name, nights }
 * @param {"welcome"|"thankyou"} kind
 * @returns {"whatsapp"|"email"|"both"|"none"}
 */
export function autoSend(row, kind = "welcome") {
  const build = kind === "thankyou" ? buildThankYouMessage : buildWelcomeMessage;
  const text  = build(row);
  const subject = kind === "thankyou"
    ? "Vielen Dank für Ihren Aufenthalt im MainSpessartBlick"
    : "Willkommen im MainSpessartBlick";

  const hasPhone = !!(row.guest_phone && cleanPhone(row.guest_phone));
  const hasMail  = !!(row.guest_email && String(row.guest_email).includes("@"));

  if (!hasPhone && !hasMail) {
    toast.error("Kein Kontakt hinterlegt (weder Handy noch E-Mail).");
    return "none";
  }

  if (hasPhone) window.open(waUrl(row.guest_phone, text), "_blank", "noopener,noreferrer");
  if (hasMail)  window.open(mailUrl(row.guest_email, subject, text), "_blank", "noopener,noreferrer");

  if (hasPhone && hasMail) {
    toast.success(`WhatsApp + E-Mail an ${row.first_name || row.name || "Gast"} vorbereitet`);
    return "both";
  }
  if (hasPhone) {
    toast.success(`WhatsApp an ${row.guest_phone} vorbereitet`);
    return "whatsapp";
  }
  toast.success(`E-Mail an ${row.guest_email} vorbereitet`);
  return "email";
}

/** Kompakter Label-Text je nach vorhandenen Kanälen. */
export function channelsLabel(row) {
  const p = !!(row.guest_phone && cleanPhone(row.guest_phone));
  const m = !!(row.guest_email && String(row.guest_email).includes("@"));
  if (p && m) return "WhatsApp + Mail";
  if (p)      return "WhatsApp";
  if (m)      return "E-Mail";
  return "Kein Kontakt";
}
